import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./subscription.css";
import { SubscriptionAction } from "../../../Redux/action/SubscriptionAction";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Spinner } from "react-bootstrap";
import Pagination from "../../Common/Pagination/Pagination";
import { FiFilter } from "react-icons/fi";
import {
  FaBuilding,
  FaCheckCircle,
  FaEdit,
  FaEllipsisH,
  FaEye,
  FaGift,
  FaRegFileAlt,
  FaRegQuestionCircle,
  FaTimes,
  FaUser,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import dayjs from "dayjs";
import { useSaveSubscription } from "../../../Hooks/useSaveSubscription.js";
import { useDeleteSubscription } from "../../../Hooks/useDeleteSubscription.js";
import { FaRegUser } from "react-icons/fa6";
import { BsThreeDotsVertical } from "react-icons/bs";

const SubscriptionPage = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setSize] = useState(10);
  const [status, setStatus] = useState("");
  const loader = useSelector((state) => state?.SubscriptionListing?.loading);
  const SubscriptionData = useSelector(
    (state) => state?.SubscriptionListing?.result?.content || []
  );
  const totalPages = useSelector(
    (state) => state?.SubscriptionListing?.result?.totalPages
  );

  const [formData, setFormData] = useState({
    subscriptionId: null,
    price: "",
    subscriptionType: "",
    userType: "",
    MdisPER: "",
    QdisPER: "",
    HYdisPER: "",
    YdisPER: "",
    maxApplications: "",
    maxJobs: "",
    maxTeamMembers: "",
    maxInterviews: "",
  });

  const [width, setWidth] = useState(window.innerWidth);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData({
      subscriptionId: "",
      price: "",
      subscriptionType: "",
      userType: "",
      MdisPER: 0,
      QdisPER: 0,
      HYdisPER: 0,
      YdisPER: 0,
      maxApplications: "",
      maxJobs: "",
      maxTeamMembers: "",
      maxInterviews: "",
    });
  };
  const { mutate: saveSubscription } = useSaveSubscription({
    onSuccess: () => {
      handleCloseModal(); // Close modal on save
    },
    onError: () => {
      console.log("Save failed");
    },
  });
  const { mutate: deleteSubscription } = useDeleteSubscription({
    onSuccess: () => {
      dispatch(SubscriptionAction({ pageNumber, status, size }));
    },
  });

  useEffect(() => {
    setPageNumber(0);
  }, [status]);

  useEffect(() => {
    dispatch(SubscriptionAction({ pageNumber, status, size }));
  }, [pageNumber, status, !isModalOpen, isModalOpen, size]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (page) => setPageNumber(page);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "subscriptionType" && value == "FREE") {
      setFormData((prev) => ({
        ...prev,
        price: 0,
        maxApplications: 0,
        maxInterviews: 0,
        maxJobs: 0,
        maxTeamMembers: 0,
        [name]: value,
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalSubmit = {
      subscriptionId: formData.subscriptionId,
      price: formData.price,
      subscriptionType: formData.subscriptionType,
      userType: formData.userType,
      maxApplications: formData.maxApplications || 0,
      maxJobs: formData.maxJobs || 0,
      maxTeamMembers: formData.maxTeamMembers || 0,
      maxInterviews: formData.maxInterviews || 0,
      discountPercentage: {
        MONTHLY: formData.MdisPER || 0,
        QUARTERLY: formData.QdisPER || 0,
        HALF_YEARLY: formData.HYdisPER || 0,
        YEARLY: formData.YdisPER || 0,
      },
    };
    saveSubscription(finalSubmit).then((res) => {
      handleCloseModal();
    });
  };

  const handleDelete = (Stype, Utype) => {
    deleteSubscription({ subscriptionType: Stype, userType: Utype });
  };

  const navigate = useNavigate();
  const [showOptionsForId, setShowOptionsForId] = useState(null);
  const optionsRef = useRef(null);

  const toggleOptions = (id) => {
    setShowOptionsForId(showOptionsForId === id ? null : id);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#f6f9ff",
          minHeight: "100%",
          paddingTop: "20px",
        }}
      >
        <div
          className="common_wrapper"
          style={{ width: "95%", backgroundColor: "white" }}
        >
          <div
            className="card-header common_table_header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <div>Subscription Management</div>
            <div style={{ display: "flex", gap: "5px" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <FiFilter
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                />
                <select
                  style={{
                    padding: "4px 12px 4px 32px", // Padding adjusted to make space for the icon
                    borderRadius: "4px",
                    fontSize: "16px",
                    border: "1px solid #e2e8f0",
                    appearance: "none",
                  }}
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">ALL</option>
                  <option value="true">Active</option>
                  <option value="false">Expired</option>
                </select>
              </div>
              <button
                onClick={() => setIsModalOpen(true)}
                className="nj_btn nav-link active bg_primary color_white"
                style={{ backgroundColor: "red", fontSize: 16 }}
              >
                Add Subscription
              </button>
            </div>
          </div>
          <div
            className="card-body overflow-auto"
            style={{ maxHeight: "600px" }}
          >
            <table
              className="table"
              style={{
                minWidth: "900px",
                borderCollapse: "separate",
                borderSpacing: "0 8px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
                  <th>Subscription ID</th>
                  <th>Subscription Type</th>
                  <th>Created Date</th>
                  <th>User Type</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      <div style={{ padding: "20px", fontSize: "15px" }}>
                        <Spinner style={{ color: "#286a94" }} />
                      </div>
                    </td>
                  </tr>
                ) : SubscriptionData.length > 0 ? (
                  SubscriptionData.map((item) => (
                    <tr
                      key={item.subscriptionId}
                      style={{
                        backgroundColor: "#fff",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                        borderRadius: "8px",
                        marginBottom: "8px",
                        display: "table-row",
                      }}
                    >
                      <td>{item.planId}</td>
                      <td>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: 500,
                            padding: "4px 10px",
                            whiteSpace: "nowrap",
                            color:
                              item.subscriptionType === "ENTERPRISE"
                                ? "#ffffff"
                                : item.subscriptionType === "BASIC"
                                ? "#286a94"
                                : item.subscriptionType === "FREE"
                                ? "#ff9f00"
                                : "#000000",
                            backgroundColor:
                              item.subscriptionType === "ENTERPRISE"
                                ? "#286a94"
                                : item.subscriptionType === "BASIC"
                                ? "#cbf0ff"
                                : item.subscriptionType === "FREE"
                                ? "#fff4e0"
                                : "#d1d1d1", 
                          }}
                        >
                          {item.subscriptionType === "ENTERPRISE" && (
                            <FaBuilding />
                          )}
                          {item.subscriptionType === "BASIC" && <FaRegUser />}
                          {item.subscriptionType === "FREE" && <FaGift />}
                          {!["ENTERPRISE", "BASIC", "FREE"].includes(
                            item.subscriptionType
                          ) && <FaRegQuestionCircle />}
                          {item.subscriptionType}
                        </span>
                      </td>

                      <td>
                        {dayjs(item.createdDate).format("YYYY-MM-DD, HH:mm")}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: 500,
                            padding: "2px 8px",
                            backgroundColor: (() => {
                              switch (item.userType) {
                                case "ADMIN":
                                  return "#ffe5e5";
                                case "VENDOR":
                                  return "#e0f7fa"; 
                                case "CANDIDATE":
                                  return "#e6f4ea";
                                default:
                                  return "#f0f0f0";
                              }
                            })(),
                            color: (() => {
                              switch (item.userType) {
                                case "ADMIN":
                                  return "#a50000"; 
                                case "VENDOR":
                                  return "#007d8c";
                                case "CANDIDATE":
                                  return "#007d3b"; 
                                default:
                                  return "#666"; 
                              }
                            })(),
                          }}
                        >
                          {item.userType === "ADMIN" && <FaUserTie />}
                          {item.userType === "VENDOR" && <FaUsers />}
                          {item.userType === "CANDIDATE" && <FaUser />}
                          {!["ADMIN", "VENDOR", "CANDIDATE"].includes(
                            item.userType
                          ) && <FaRegQuestionCircle />}
                          {item.userType}
                        </span>
                      </td>

                      <td>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            fontWeight: 500,
                            padding: "4px 8px",
                            color: item.status ? "#007d3b" : "#a50000",
                            backgroundColor: item.status
                              ? "#cbffe1"
                              : "#ffd6d6",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.status ? (
                            <>
                              <FaCheckCircle />
                              Active
                            </>
                          ) : (
                            <>
                              <FaTimes />
                              Expired
                            </>
                          )}
                        </span>
                      </td>

                      <td style={{ position: "relative" }}>
                        <button
                          onClick={() => toggleOptions(item.subscriptionId)}
                          style={{
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "1.25rem",
                          }}
                        >
                          <BsThreeDotsVertical color="#286a94" />
                        </button>
                        {showOptionsForId === item.subscriptionId && (
                          <div
                            style={{
                              position: "absolute",
                              top: "30px",
                              right: 0,
                              width: "160px",
                              background: "#fff",
                              borderRadius: "8px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                              zIndex: 20,
                              padding: "8px 0",
                            }}
                          >
                            <div
                              className="dropdown-item"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 16px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate(
                                  `/admin/subscription/details?id=${item.planId}`,
                                  {
                                    state: {
                                      plan: item.planId,
                                      id: item.subscriptionId,
                                      userType: item.userType,
                                      subscriptionType: item.subscriptionType,
                                    },
                                  }
                                )
                              }
                            >
                              <FaEye
                                style={{ marginRight: "8px", color: "#286a94" }}
                              />
                              <span>View</span>
                            </div>
                            {item.status && (
                              <div
                                className="dropdown-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 16px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setFormData({
                                    ...formData,
                                    subscriptionId: item.subscriptionId,
                                    price: item.price || "",
                                    subscriptionType:
                                      item.subscriptionType || "",
                                    userType: item.userType || "",
                                    MdisPER:
                                      item.discountPercentageList?.MONTHLY,
                                    QdisPER:
                                      item.discountPercentageList?.QUARTERLY,
                                    HYdisPER:
                                      item.discountPercentageList?.HALF_YEARLY,
                                    YdisPER:
                                      item.discountPercentageList?.YEARLY,
                                    maxApplications: item.maxApplications || "",
                                    maxJobs: item.maxJobs || "",
                                    maxTeamMembers: item.maxTeamMembers || "",
                                    maxInterviews: item.maxInterviews || "",
                                  });
                                  setIsModalOpen(true);
                                }}
                              >
                                <FaEdit
                                  style={{
                                    marginRight: "8px",
                                    color: "#ffc107",
                                  }}
                                />
                                <span>Edit</span>
                              </div>
                            )}
                            {item.status && (
                              <div
                                className="dropdown-item"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 16px",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleDelete(
                                    item.subscriptionType,
                                    item.userType
                                  )
                                }
                              >
                                <MdDeleteOutline
                                  style={{
                                    marginRight: "8px",
                                    color: "#dc3545",
                                  }}
                                />
                                <span>Delete</span>
                              </div>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {SubscriptionData.length > 0 && (
              <Pagination
                totalPages={totalPages}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
        {isModalOpen && (
          <div className="modal-overlay-off">
            <div className="modal-container">
              <h4>
                {formData.subscriptionId ? "Update" : "Create"} Subscription
                Plan
              </h4>
              <hr style={{ marginBottom: "20px" }} />
              <form onSubmit={handleSubmit}>
                <div className="form-grid">
                  {/* <div className="form-group-admin">
                                        <label>Duration</label>
                                        <select className="form-control" required name="duration" disabled={formData.subscriptionType === "FREE"} value={formData.duration} onChange={handleChange}>
                                            <option value="" disabled={true} >Select</option>
                                            <option value="MONTHLY">Monthly</option>
                                            <option value='QUARTERLY'>Quaterly</option>
                                            <option value='HALF_YEARLY'>Half Yearly</option>
                                            <option value='YEARLY'>Yearly</option>
                                        </select>
                                    </div> */}
                  <div className="form-group-admin">
                    <label>Subscription Type</label>
                    <select
                      className="form-control"
                      required
                      disabled={formData.subscriptionId}
                      name="subscriptionType"
                      value={formData.subscriptionType}
                      onChange={handleChange}
                    >
                      <option value="" disabled={true}>
                        Select
                      </option>
                      <option value="FREE">Free</option>
                      <option value="BASIC">Basic</option>
                      <option value="PREMIUM">Premium</option>
                      <option value="ENTERPRISE">Enterprise</option>
                    </select>
                  </div>
                  <div className="form-group-admin">
                    <label>User Type</label>
                    <select
                      className="form-control"
                      required
                      disabled={formData.subscriptionId}
                      name="userType"
                      value={formData.userType}
                      onChange={handleChange}
                    >
                      <option value="" disabled={true}>
                        Select
                      </option>
                      <option value="CANDIDATE">Candidate</option>
                      <option value="VENDOR">Vendor</option>
                    </select>
                  </div>
                  <div className="form-group-admin">
                    <label>Price</label>
                    <input
                      className="form-control"
                      min={0}
                      placeholder="0 Rs"
                      required
                      type="number"
                      disabled={formData.subscriptionType == "FREE"}
                      name="price"
                      value={formData.price || ""}
                      onChange={handleChange}
                    />
                  </div>
                  {
                    <div className="form-group-admin">
                      <label>Max Apply Jobs</label>
                      <input
                        className="form-control"
                        placeholder="0"
                        required
                        type="number"
                        name="maxApplications"
                        min={0}
                        value={formData.maxApplications || ""}
                        onChange={handleChange}
                      />
                    </div>
                  }
                  {formData.userType === "VENDOR" && (
                    <div className="form-group-admin">
                      <label>Max Jobs Posted</label>
                      <input
                        className="form-control"
                        placeholder="0"
                        required={formData.userType === "VENDOR" ? true : false}
                        type="number"
                        min={0}
                        name="maxJobs"
                        value={formData.maxJobs || ""}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                  {formData.userType === "VENDOR" && (
                    <div className="form-group-admin">
                      <label>Max Team Members</label>
                      <input
                        className="form-control"
                        placeholder="0"
                        required={formData.userType === "VENDOR" ? true : false}
                        type="number"
                        min={0}
                        name="maxTeamMembers"
                        value={formData.maxTeamMembers || ""}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                  {formData.userType === "VENDOR" && (
                    <div className="form-group-admin">
                      <label>Max Interviews scheduled</label>
                      <input
                        className="form-control"
                        placeholder="0"
                        required={formData.userType === "VENDOR" ? true : false}
                        type="number"
                        min={0}
                        name="maxInterviews"
                        value={formData.maxInterviews || ""}
                        onChange={handleChange}
                      />
                    </div>
                  )}
                </div>
                <div className="discount-form-data">
                  <label>Monthly Discount Percentage({formData.price})</label>
                  <select
                    className="form-control select-width"
                    disabled={formData.subscriptionType === "FREE"}
                    name="MdisPER"
                    value={formData.MdisPER || ""}
                    onChange={handleChange}
                    required
                  >
                    {/* <option value={''} disabled={true}>Select</option> */}
                    <option value={0}>No Discount</option>
                    {Array.from({ length: 8 }, (_, index) => {
                      const percentage = index * 5 + 5;
                      return (
                        <option key={percentage} value={percentage}>
                          {percentage}%
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="discount-form-data">
                  <label>
                    Quaterly Discount Percentage({formData.price * 3})
                  </label>
                  <select
                    className="form-control select-width"
                    disabled={formData.subscriptionType === "FREE"}
                    name="QdisPER"
                    value={formData.QdisPER || ""}
                    onChange={handleChange}
                    required
                  >
                    {/* <option value={''} disabled={true}>Select</option> */}
                    <option value={0}>No Discount</option>
                    {Array.from({ length: 8 }, (_, index) => {
                      const percentage = index * 5 + 5;
                      return (
                        <option key={percentage} value={percentage}>
                          {percentage}%
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="discount-form-data">
                  <label>
                    Half Yearly Discount Percentage({formData.price * 6})
                  </label>
                  <select
                    className="form-control select-width"
                    disabled={formData.subscriptionType === "FREE"}
                    name="HYdisPER"
                    value={formData.HYdisPER || ""}
                    onChange={handleChange}
                    required
                  >
                    {/* <option value={''} disabled={true}>Select</option> */}
                    <option value={0}>No Discount</option>
                    {Array.from({ length: 8 }, (_, index) => {
                      const percentage = index * 5 + 5;
                      return (
                        <option key={percentage} value={percentage}>
                          {percentage}%
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="discount-form-data">
                  <label>
                    Yearly Discount Percentage({formData.price * 12})
                  </label>
                  <select
                    className="form-control select-width"
                    disabled={formData.subscriptionType === "FREE"}
                    name="YdisPER"
                    value={formData.YdisPER || ""}
                    onChange={handleChange}
                    required
                  >
                    {/* <option value={''} disabled={true}>Select</option> */}
                    <option value={0}>No Discount</option>
                    {Array.from({ length: 8 }, (_, index) => {
                      const percentage = index * 5 + 5;
                      return (
                        <option key={percentage} value={percentage}>
                          {percentage}%
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div style={{ marginTop: 30 }} className="form-actions">
                  <button className="btn_off_modal" type="submit">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn_off_modal"
                    onClick={() => {
                      handleCloseModal();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubscriptionPage;
